import * as z from "zod";
import { mutator } from "./mutator";

export const recordLinkCopied = mutator({
  schema: z.object({
    object: z.string().max(32),
    page: z.string().max(32),
  }),
  resolve: {},
  permissions: {
    none: "records that the caller copied a link from their own screen",
  },
  description:
    "Triggered when a user copies a workflow, route, space, or git link to share it.",
  interactionType: "view",
  fn: async () => {},
});
